import { scrollTo } from "lib/utils/scroll";
import React from "react";
import { withRouter } from "react-router-dom";

interface IScrollToTop {
  [label: string]: any;
}

/**
 * Container element, which scroll to top of window on it's content update.
 */
class ScrollToTop extends React.Component<IScrollToTop> {
  constructor(props) {
    super(props);
  }
  public componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      scrollTo();
    }
  }

  public render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/app/modules/scrollToTop/ScrollToTop.tsx